import React, { createContext, useMemo, useReducer } from 'react';

import PusherHandler from './PusherHandler';
import actionsFactory, { CombinedActions } from './actionsFactory';
import combinedReducer, { State, initState } from './combinedReducer';

type ContextType = {
  actions: CombinedActions;
} & State;

const initContext = {
  ...initState,
  actions: actionsFactory(() => {}),
};

const UserEnvironmentContext = createContext<ContextType>(initContext);

const UserEnvironmentContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(combinedReducer, initState);
  const actions = useMemo(() => actionsFactory(dispatch), [dispatch]);

  const contextValue = {
    ...state,
    actions,
  };

  return (
    <>
      <PusherHandler dispatch={dispatch} actions={actions} state={state} />
      <UserEnvironmentContext.Provider value={contextValue}>
        {children}
      </UserEnvironmentContext.Provider>
    </>
  );
};

export { UserEnvironmentContext, UserEnvironmentContextProvider };
